import { useState } from 'react';
//import Context from '../context/UserContext';


export default function useToken() {

  const getToken = () => {
    const tokenString = localStorage.getItem('token');
    if (tokenString) {
      const userToken = JSON.parse(tokenString);
      return userToken;
    } else {
      return null;
    }
  };

  const [token, setToken] = useState(getToken());

  const saveToken = (userToken: any) => {
    localStorage.setItem('token', JSON.stringify(userToken));
    setToken(userToken);
  };

  return {
    setToken: saveToken,
    token,
    isLogged: Boolean(token),

  };
}
